// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#checkout-payment table{width:100%}#checkout-payment h2{margin-bottom:.5em;margin-top:1em}#checkout-payment td{padding-bottom:.5em}#checkout-payment td:first-child{width:32px}", ""]);
// Exports
module.exports = exports;
